import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

type RedirectToLoginTypes = {
  setRegistrationModalOpen: () => void;
};

const RedirectToLogin = (props: RedirectToLoginTypes) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const query = location.search;
    history.push(`/login/${query}`);
    props.setRegistrationModalOpen();
  }, [history, location]);

  return null; // Optionally, render nothing if the component is just for redirection
};

function mapDispatchToProps(dispatch) {
  return {
    setRegistrationModalOpen: () => {
      dispatch.registrationFormModel.setRegistrationModalOpen();
    },
  };
}

export default connect(null, mapDispatchToProps)(RedirectToLogin);
